module.exports = __webpack_public_path__ + "img/00_Illustration_420px_520px.b577397c.png";